import React from 'react'
import { urlify } from '../../utils/common'
import { blue } from '../../color'

export const RichText = ({ text, ...props }) => {
  return (
    <div
      {...props}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  )
}

export const EmptyText = ({ children = 'Không có' }) => (
  <i style={{ color: '#928e8ecc', display: 'inline-block', minWidth: 70 }}>
    {children}
  </i>
)

export const TitleContentBox = props => {
  const style = {
    fontWeight: 500,
    fontSize: 14,
    margin: '-16px -16px 10px -16px',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    padding: '10px 16px',
    color: '#fff',
    backgroundColor: blue,
  }
  return <h3 style={style}>{props.children}</h3>
}

export const trimOverLengthString = (string, width) => {
  const style = {
    display: 'block',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    width: width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }

  return <span style={style}>{string}</span>
}

export const trimOverlengthString = (string, width) => {
  const style = {
    display: 'block',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    width: width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }

  return <span style={style}>{string}</span>
}

export const TextWrapUnread = props => (
  <div
    style={{
      display: 'block',
      color: 'rgba(0,0,0)',
      fontWeight: 'bolder',
      wordWrap: 'break-word',
      wordBreak: 'break-all',
      width: props?.width || 100,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
    {props.children}
  </div>
)

export const TextWrap = props => (
  <a
    style={{
      display: 'block',
      color: 'rgba(0,0,0)',
      wordWrap: 'break-word',
      wordBreak: 'break-all',
      width: props.width,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
    {props.children}
  </a>
)

export const WordBreak = (content, isDangerouslySetInnerHTML = false) => {
  const style = {
    wordBreak: 'normal',
    whiteSpace: 'pre-line',
  }
  if (isDangerouslySetInnerHTML) {
    return <div dangerouslySetInnerHTML={{ __html: content }} />
  }
  return <div style={style}>{content}</div>
}

export const UrlifiedText = text => {
  if (text) {
    const urlifiedText = urlify(text)
    return (
      <div
        className="overflow-hidden whitespace-nowrap "
        dangerouslySetInnerHTML={{ __html: urlifiedText }}
      />
    )
  }
  return <EmptyText>Không có</EmptyText>
}

export const subStringAvatar = name => name?.substring(0, 1).toUpperCase()

export const SingleLineEllipsis = props => (
  <div
    style={{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#0075ff',
    }}>
    {props.children}
  </div>
)
